import haversine from 'haversine-distance';
import * as THREE from 'three';

export function computeAverageCoordinates(locations) {
    if (locations.length === 0) {
        return null; // Return null if the array is empty
    }

    let totalX = 0;
    let totalY = 0;
    let totalZ = 0;

    // Convert latitude and longitude to Cartesian coordinates
    locations.forEach(location => {
        const latRad = location.lat * Math.PI / 180;
        const lonRad = location.lng * Math.PI / 180;

        totalX += Math.cos(latRad) * Math.cos(lonRad);
        totalY += Math.cos(latRad) * Math.sin(lonRad);
        totalZ += Math.sin(latRad);
    });

    // Compute average Cartesian coordinates
    const avgX = totalX / locations.length;
    const avgY = totalY / locations.length;
    const avgZ = totalZ / locations.length;

    // Convert average Cartesian coordinates back to latitude and longitude
    const avgLonRad = Math.atan2(avgY, avgX);
    const hyp = Math.sqrt(avgX * avgX + avgY * avgY);
    const avgLatRad = Math.atan2(avgZ, hyp);

    const avgLat = avgLatRad * 180 / Math.PI;
    const avgLon = avgLonRad * 180 / Math.PI;

    return { lat: avgLat, lng: avgLon }; // Return an object containing average lat and lng
}

export function clusterLocations(locations, threshold = 1000) {
    const grouped = [];
    if(!locations || !locations.length) return [];

    for (let i = 0; i < locations.length; i++) {
        const currentLocation = locations[i];
        let group = { items: [currentLocation] };

        for (let j = i + 1; j < locations.length; j++) {
            const nextLocation = locations[j];
            const distance = haversine(currentLocation, nextLocation);

            if (distance <= threshold * 1000) {
                group.items.push(nextLocation);
                locations.splice(j, 1);
                j--; // Adjust index due to removed element
            }
        }

        grouped.push(group);
    }

    return grouped.map(group => {
        if(group.items.length == 1) return group.items[0]
        else {
            const {lat, lng} = computeAverageCoordinates(group.items);
            group.lat = lat;
            group.lng = lng;

            return group; 
        }           
    })
}

// convert the positions from a lat, lon to a position on a sphere.
export function latLongToVector3(lat, lon, radius = 1) {
    var phi = (lat)*Math.PI/180;
    var theta = (lon-180)*Math.PI/180;

    var x = -(radius) * Math.cos(phi) * Math.cos(theta);
    var y = (radius) * Math.sin(phi);
    var z = (radius) * Math.cos(phi) * Math.sin(theta);

    return new THREE.Vector3(x,y,z);
}

export function vector3ToLatLong(vector3) {
    // Calculate longitude
    var lon = Math.atan2(vector3.z, -vector3.x);

    // Calculate latitude
    var equatorProj = Math.sqrt(vector3.x * vector3.x + vector3.z * vector3.z);
    var lat = Math.atan2(vector3.y, equatorProj);

    // Convert radians to degrees
    lon = lon * 180 / Math.PI;
    lat = lat * 180 / Math.PI;

    // Adjust longitude to be in the range (-180, 180)
    lon = (lon + 360) % 360;
    if (lon > 180) {
        lon -= 360;
    }

    return { lat: lat, lon: lon };
}

export function getApproxLongitudeFromUser() {
    const timezoneOffset = new Date().getTimezoneOffset();

    // Approximate longitude range per hour offset (in degrees)
    const degreesPerHour = -15; // Earth rotates 15 degrees per hour
    
    // Convert timezone offset from minutes to hours
    const hoursOffset = timezoneOffset / 60;
    
    // Calculate the approximate longitude range
    const longitude = hoursOffset * degreesPerHour;
    
    return longitude;
}
